<template>
  <FormKit
    id="username"
    v-model="value"
    autocomplete="username"
    name="username"
    required
    :label="$texts('loginUserLabel', 'E-Mail, FPH-Nummer oder GLN')"
  >
    <template #suffixIcon>
      <div class="pointer-events-none ml-10 mr-10 text-green-alt select-none">
        <SpriteSymbol v-if="isEmail" name="email" class="w-30 h-30" />
        <div v-else-if="isGLN" class="font-semibold">GLN</div>
        <div v-else-if="isFPH" class="font-semibold">FPH</div>
        <SpriteSymbol
          v-else
          name="individual_member"
          class="w-20 h-20 text-gray-500"
        />
      </div>
    </template>
  </FormKit>
</template>

<script lang="ts" setup>
await initFormKit()

const props = defineProps<{
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(v: string) {
    emit('update:modelValue', v)
  },
})

const isGLN = computed<boolean>(() => {
  return value.value.length === 13 && /^\d+$/.test(value.value)
})

const isFPH = computed<boolean>(() => {
  return value.value.length === 7 && /^\d+$/.test(value.value)
})

const isEmail = computed<boolean>(() => {
  return /@./.test(value.value)
})
</script>
